<script setup lang="ts">
import CanvasButton from "../../CanvasButton.vue";
import { useSnapControls } from "@/composable/useSnapControls";

const { isOrthoActive, toggleOrtho } = useSnapControls();
</script>

<template>
  <CanvasButton
    phosphor-icon="vector-two"
    :mode="isOrthoActive"
    :tooltip-title="$t('canvas:tools.snap.orthoTitle')"
    :tooltip-text="$t('canvas:tools.snap.ortho')"
    @click="toggleOrtho"
  />
</template>
